// import {Configurator, DashboardNavbar, Footer, Sidenav,} from "@/widgets/layout";
import {StatisticsCard} from './widgets/statistics-card'
import {BsArrowReturnLeft, BsCalendar2Event, BsGearWideConnected} from "react-icons/bs";
import {Card, CardBody, CardHeader, Typography} from "@material-tailwind/react";
import React from "react";
import StatisticsChart from "./widgets/statistics-chart";
import PieChart from "./charts/pie_chart";
import persianNumberFormat from "../../helper/PersianNumberFormat";

export function TodayServicesDashboard({todayServices, from}) {

  const compare_text = (new_count, pre_count, title) => {
    const count_difference = new_count - pre_count;
    if (count_difference === 0) {
      return 'مشابه روز گذشته'
    } else if (count_difference > 0) {
      return persianNumberFormat(`${count_difference} ${title} بیشتر از روز گذشته`)
    } else if (count_difference < 0) {
      return persianNumberFormat(`${Math.abs(count_difference)} ${title} کمتر از روز گذشته`)
    }
  }

  return (
    <div className={`w-full ${from === "admin" ? "mt-8" : ""}`}>
      <Card className="pt-8 w-full bg-gray-200">
        <CardHeader floated={true} shadow={false} className="bg-gray">
          <div className="mb-8 flex flex-col items-start justify-between md:flex-row">
            <Typography variant="h5" color="blue-gray">رزروهای امروز</Typography>
          </div>

        </CardHeader>
        <CardBody className="overflow-x-auto w-full">

          <div className="grid grid-cols-1 gap-1 mb-8 md:grid-cols-4 xxl:grid-cols-6">
            <StatisticsCard color="gray" title="سرویس‌های امروز" value={todayServices.today_works_count}
                            footer={compare_text(todayServices.today_works_count, todayServices.yesterday_works_count, 'سرویس')}
                            icon={<BsArrowReturnLeft size={50}/>}/>
            <StatisticsCard color="gray" title="رزروهای مشاوره امروز" value={todayServices.today_consultations_count}
                            footer={compare_text(todayServices.today_consultations_count, todayServices.yesterday_consultations_count, 'مشاوره')}
                            icon={<BsCalendar2Event size={50}/>}/>
            <StatisticsCard color="gray" title="خدمات امروز" value={todayServices.today_services_count}
                            footer={compare_text(todayServices.today_services_count, todayServices.yesterday_services_count, 'خدمات')}
                            icon={<BsGearWideConnected size={50}/>}/>
          </div>

          <div className="grid grid-cols-1 gap-1 mb-8 md:grid-cols-2 xxl:grid-cols-6">
            {todayServices.today_consultations_count + todayServices.today_services_count > 0 &&
              <StatisticsChart
                color="#fff"
                chart={PieChart(
                  [todayServices.today_consultations_count, todayServices.today_services_count],
                  ['مشاوره', 'خدمات']
                )}
                title="سرویس های امروز به تفکیک"
                description="سرویس های امروز به تفکیک خدمات و مشاوره"
                // footer={updated_footer}
              />
            }

            {
              todayServices.today_consultations_field_count.count &&
              <StatisticsChart
                color="#fff"
                chart={PieChart(
                  todayServices.today_consultations_field_count.count,
                  todayServices.today_consultations_field_count.title
                )}
                title="سرویس های مشاوره امروز به تفکیک"
                description="سرویس های مشاوره امروز به تفکیک رشته‌ها"
                // footer={updated_footer}
              />
            }

            {
              todayServices.today_consultations_branch_count.count &&
              <StatisticsChart
                color="#fff"
                chart={PieChart(
                  todayServices.today_consultations_branch_count.count,
                  todayServices.today_consultations_branch_count.title
                )}
                title="سرویس های مشاوره امروز به تفکیک"
                description="سرویس های مشاوره امروز به تفکیک گرایش‌ها"
                // footer={updated_footer}
              />
            }

            {
              todayServices.today_services_field_count.count &&
              <StatisticsChart
                color="#fff"
                chart={PieChart(
                  todayServices.today_services_field_count.count,
                  todayServices.today_services_field_count.title
                )}
                title="سرویس های خدمات امروز به تفکیک"
                description="سرویس های خدمات امروز به تفکیک رشته‌ها"
                // footer={updated_footer}
              />
            }

            {
              todayServices.today_services_branch_count.count &&
              <StatisticsChart
                color="#fff"
                chart={PieChart(
                  todayServices.today_services_branch_count.count,
                  todayServices.today_services_branch_count.title
                )}
                title="سرویس های خدمات امروز به تفکیک"
                description="سرویس های خدمات امروز به تفکیک گرایش‌ها"
                // footer={updated_footer}
              />
            }

          </div>

        </CardBody>
      </Card>
    </div>
  );
}


export default TodayServicesDashboard;
